/**
 * Product gallery
 */
var component_product_gallery = function(args) {

  // setup args
  var container = args.container; // match this to $menu-visible SASS variable
  var top = container.querySelector('.gallery-top');
  var thumbs = container.querySelector('.gallery-thumbs');

  if (thumbs) {
    // Bottom gallery (thumbnails)
    if (thumbs.querySelectorAll('.swiper-slide').length > 1) {
      var galleryThumbs = new Swiper (thumbs, {
        // optional parameters
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 16,
      })
    }
  }

  // Top gallery
  if (top) {
    if (top.querySelectorAll('.swiper-slide').length > 1) {
      var galleryTop = new Swiper (top, {
         // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        // optional parameters
        direction: 'horizontal',
        loop: true,
        grabCursor: true,

        // navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // connect the thumbnail slider
        thumbs: {
          swiper: galleryThumbs,
        }
      })
    } else {
      top.classList.add('disabled');
    }
  }

  // make the call chainable
  return this;

};
